import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import { connect } from "react-redux";
import {
  AutoComplete,
  Button,
  Icon,
  Alert,
  Tabs,
  Input,
  Form,
  Tag,
} from "antd";

import classes from "./SpecimenSample.css";

import { logout } from "../../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import {
  getSpecimenSampleEvents,
  createSpecimenProfileEvent,
  updateSpecimenProfileEvent,
  detachSpecimenProfileEvent,
  getSpecimenSamplesAutocompleteSearchRequest,
} from "../../../api/requests";
import ResultUploadForm from "./ResultUploadForm";
import FormBuilderCustomView from "../../FormBuilder/FormBuilderCustomView";

const { TabPane } = Tabs;

class SpecimenSample extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoadingDetach: false,
      errorMessage: null,
      eventsList: null,
      specimenCode: null,
      isSubmitted: null,
      defaultActiveKey: "0",
      defaultActiveKeyForms: "0",
      codeOptions: [],
    };
  }

  async componentDidMount() {
    this.getSpecimenSamples();
  }

  onSearch = async (nameSearch) => {
    if (nameSearch && nameSearch.length > 2) {
      const { data } = await getSpecimenSamplesAutocompleteSearchRequest({
        nameSearch,
        page: 1,
        per_page: 10,
        siteCode: this.props.siteCode,
      });

      this.setState({
        codeOptions: data.map(({ code }) => code),
      });
    }
  };

  getSpecimenSamples = async () => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getSpecimenSampleEvents(this.props.subjectID);

      this.setState({ eventsList: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({ errorMessage: get(e, "response.data.error", "Error") });
    }

    this.setState({ isLoading: false });
  };

  onSubmit = async (values, slug, id, form_slug, specimenCode) => {
    const data = {
      [form_slug]: {
        [slug]: { ...values },
      },
    };

    if (specimenCode) {
      try {
        await createSpecimenProfileEvent(
          { code: specimenCode, ...data },
          { subjectID: this.props.subjectID, id }
        );
      } catch (e) {
        this.setState({
          specimenCodeError: get(e, "response.data.errors.code[0]"),
        });
        throw e;
      }
    } else {
      await updateSpecimenProfileEvent(data, {
        subjectID: this.props.subjectID,
        id,
      });
    }

    setTimeout(() => {
      this.getSpecimenSamples();
    }, 1000);
  };

  detachSpecimen = async (id) => {
    this.setState({ isLoadingDetach: true });
    try {
      await detachSpecimenProfileEvent({ subjectID: this.props.subjectID, id });
      this.setState({ isLoadingDetach: false, defaultActiveKeyForms: "0" });
      this.getSpecimenSamples();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  };

  onSelect = (value) => {
    this.setState({
      specimenCode: value,
      specimenCodeError: null,
      codeOptions: [],
    });
    this.onSearch(this.state.specimenCode);
  };

  render() {
    const {
      isLoading,
      errorMessage,
      eventsList,
      isSubmitted,
      specimenCode,
      specimenCodeError,
      isLoadingDetach,
    } = this.state;

    return (
      <div>
        {isLoading ? (
          <Icon type="loading" />
        ) : (
          !errorMessage && (
            <div>
              <div className={classes.tabHead}>
                <Tabs
                  defaultActiveKey={this.state.defaultActiveKey}
                  animated={false}
                  onChange={(defaultActiveKey) => {
                    this.setState({
                      defaultActiveKey,
                      defaultActiveKeyForms: "0",
                      specimenCode: null,
                      isSubmitted: null,
                      specimenCodeError: null,
                    });
                  }}
                >
                  {map(eventsList, (event, i) => (
                    <TabPane
                      tab={
                        <div className={classes.tabPane}>
                          {event.name}{" "}
                          <div
                            className={classes.tabPaneStatus}
                            style={{
                              background:
                                Object.keys(get(event, "result_form_data", {}))
                                  .length > 0
                                  ? "#6aca4d"
                                  : get(event, "attached_samples").length > 0
                                  ? "#d7d630"
                                  : "#aaa",
                            }}
                          />
                        </div>
                      }
                      key={i}
                    >
                      <div>
                        {get(event, "attached_samples").length > 0 ? (
                          <div
                            style={{
                              margin: "10px 0 0",
                            }}
                          >
                            <div style={{ margin: "0 0 10px" }}>
                              <b>Specimen codes:</b>
                            </div>
                            {map(
                              get(event, "attached_samples", []),
                              (event, i) => (
                                <div key={i} style={{ margin: "2px 0" }}>
                                  <Tag color="#2968ae">
                                    {get(event, "code")}
                                  </Tag>
                                </div>
                              )
                            )}

                            <div style={{ margin: "20px 0 0" }}>
                              <Button
                                type="danger"
                                loading={isLoadingDetach}
                                disabled={isLoadingDetach}
                                onClick={(e) => {
                                  this.detachSpecimen(event.id);
                                }}
                              >
                                Detach specimen
                              </Button>
                            </div>
                            <br />
                          </div>
                        ) : (
                          <div>
                            <div style={{ width: "200px" }}>
                              <Form.Item
                                label={this.props.i18n.t("Specimen code")}
                                required
                                validateStatus={
                                  (isSubmitted && !specimenCode) ||
                                  specimenCodeError
                                    ? "error"
                                    : ""
                                }
                                help={
                                  isSubmitted && !specimenCode
                                    ? this.props.i18n.t("Required")
                                    : specimenCodeError
                                }
                              >
                                <AutoComplete
                                  onFocus={this.onSelect}
                                  onSearch={this.onSearch}
                                  onSelect={this.onSelect}
                                  dataSource={this.state.codeOptions}
                                />
                                {/*<Input
                                  type="text"
                                  placeholder={this.props.i18n.t("Specimen code")}
                                  onChange={(event) => {
                                    this.setState({
                                      specimenCode: event.target.value,
                                      specimenCodeError: null,
                                    });
                                  }}
                                />*/}
                              </Form.Item>
                            </div>
                          </div>
                        )}

                        <div className={classes.tabForms}>
                          <Tabs
                            defaultActiveKey={this.state.defaultActiveKeyForms}
                            animated={false}
                            onChange={(defaultActiveKeyForms) => {
                              this.setState({
                                defaultActiveKeyForms,
                              });
                            }}
                          >
                            <TabPane
                              tab={
                                <div className={classes.tabPane}>
                                  Collection form{" "}
                                  <div
                                    className={classes.tabPaneStatus}
                                    style={{
                                      background:
                                        Object.keys(
                                          get(
                                            event,
                                            `collection_form_data.${get(
                                              event.collection_form_schemas,
                                              "[0].slug"
                                            )}`,
                                            {}
                                          )
                                        ).length > 0
                                          ? "#6aca4d"
                                          : "#aaa",
                                    }}
                                  />
                                </div>
                              }
                              key="0"
                            >
                              <FormBuilderCustomView
                                isEditable={true}
                                schema={get(
                                  event.collection_form_schemas,
                                  "[0].json_schema"
                                )}
                                initialValues={get(
                                  event,
                                  `collection_form_data.${get(
                                    event.collection_form_schemas,
                                    "[0].slug"
                                  )}`
                                )}
                                onFormSubmit={(data) => {}}
                                name={get(
                                  event.collection_form_schemas,
                                  "[0].name"
                                )}
                                slug={get(
                                  event.collection_form_schemas,
                                  "[0].slug"
                                )}
                                onSubmit={async (data) => {
                                  this.setState({ isSubmitted: true });
                                  if (specimenCode) {
                                    await this.onSubmit(
                                      data,
                                      get(
                                        event.collection_form_schemas,
                                        "[0].slug"
                                      ),
                                      event.id,
                                      "collection_form_data",
                                      specimenCode
                                    );
                                  }

                                  if (
                                    get(event, "attached_samples").length > 0
                                  ) {
                                    await this.onSubmit(
                                      data,
                                      get(
                                        event.collection_form_schemas,
                                        "[0].slug"
                                      ),
                                      event.id,
                                      "collection_form_data"
                                    );
                                  }
                                }}
                              />{" "}
                            </TabPane>

                            <TabPane
                              tab={
                                <div className={classes.tabPane}>
                                  Result form{" "}
                                  <div
                                    className={classes.tabPaneStatus}
                                    style={{
                                      background:
                                        Object.keys(
                                          get(
                                            event,
                                            `result_form_data.${get(
                                              event.result_form_schemas,
                                              "[0].slug"
                                            )}`,
                                            {}
                                          )
                                        ).length > 0
                                          ? "#6aca4d"
                                          : "#aaa",
                                    }}
                                  />
                                </div>
                              }
                              disabled={
                                get(event, "attached_samples").length === 0 ||
                                !get(
                                  event.result_form_schemas,
                                  "[0].json_schema"
                                )
                              }
                              key="1"
                            >
                              <FormBuilderCustomView
                                isEditable={true}
                                schema={get(
                                  event.result_form_schemas,
                                  "[0].json_schema"
                                )}
                                initialValues={get(
                                  event,
                                  `result_form_data.${get(
                                    event.result_form_schemas,
                                    "[0].slug"
                                  )}`
                                )}
                                onFormSubmit={(data) => {}}
                                name={get(
                                  event.result_form_schemas,
                                  "[0].name"
                                )}
                                slug={get(
                                  event.result_form_schemas,
                                  "[0].slug"
                                )}
                                onSubmit={async (data) => {
                                  await this.onSubmit(
                                    data,
                                    get(event.result_form_schemas, "[0].slug"),
                                    event.id,
                                    "result_form_data"
                                  );
                                }}
                              />{" "}
                            </TabPane>
                            <TabPane
                              tab={
                                <div className={classes.tabPane}>
                                  Result file{" "}
                                  <div
                                    className={classes.tabPaneStatus}
                                    style={{
                                      background: get(
                                        event,
                                        "result_document_link"
                                      )
                                        ? "#6aca4d"
                                        : "#aaa",
                                    }}
                                  />
                                </div>
                              }
                              // disabled={
                              //   get(event, "attached_samples").length === 0
                              // }
                              key="2"
                            >
                              <ResultUploadForm
                                subjectID={this.props.subjectID}
                                id={event.id}
                                url={get(event, "result_document_link")}
                                onSubmit={() => {}}
                              />
                            </TabPane>
                          </Tabs>
                        </div>

                        {/*<FormBuilderCustomViewContainer
                            slug={form.slug}
                            isModal={false}
                            subjectID={this.props.subjectID}
                            onSubmit={() => {
                              console.log("Submitted");
                            }}
                          />*/}
                      </div>
                    </TabPane>
                  ))}
                </Tabs>
              </div>
            </div>
          )
        )}
        {errorMessage && <Alert type="error" message={errorMessage} />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { logout };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(SpecimenSample));



// WEBPACK FOOTER //
// ./src/containers/PatientProfile/SpecimenSample/SpecimenSample.js